import type { VariantProps } from 'cva'
import { cva } from 'cva'

export type BadgeVariantProps = VariantProps<typeof badgeColorVariants>
export const badgeColorVariants = cva({
  variants: {
    color: {
      green:
        'bg-ui-tag-green-bg text-ui-tag-green-text [&_svg]:text-ui-tag-green-icon border-ui-tag-green-border',
      red: 'bg-ui-tag-red-bg text-ui-tag-red-text [&_svg]:text-ui-tag-red-icon border-ui-tag-red-border',
      blue: 'bg-ui-tag-blue-bg text-ui-tag-blue-text [&_svg]:text-ui-tag-blue-icon border-ui-tag-blue-border',
      orange:
        'bg-ui-tag-orange-bg text-ui-tag-orange-text [&_svg]:text-ui-tag-orange-icon border-ui-tag-orange-border',
      grey: 'bg-ui-tag-neutral-bg text-ui-tag-neutral-text [&_svg]:text-ui-tag-neutral-icon border-ui-tag-neutral-border',
      purple:
        'bg-ui-tag-purple-bg text-ui-tag-purple-text [&_svg]:text-ui-tag-purple-icon border-ui-tag-purple-border',
    },
  },
  defaultVariants: {
    color: 'grey',
  },
})

export type BadgeSizeVariantProps = VariantProps<typeof badgeSizeVariants>
export const badgeSizeVariants = cva({
  base: 'box-border inline-flex items-center gap-x-0.5 border',
  variants: {
    size: {
      '2xsmall': 'txt-compact-xsmall-plus h-5',
      xsmall: 'txt-compact-xsmall-plus h-6 py-px',
      small: 'txt-compact-xsmall-plus h-7 py-[3px]',
      base: 'txt-compact-small-plus h-8 py-[5px]',
      large: 'txt-compact-medium-plus h-10 py-[7px]',
    },
    rounded: {
      base: 'rounded-md',
      full: 'rounded-full',
    },
  },
  compoundVariants: [
    {
      size: '2xsmall',
      rounded: 'full',
      className: 'px-1.5',
    },
    {
      size: '2xsmall',
      rounded: 'base',
      className: 'px-1',
    },
    {
      size: 'xsmall',
      rounded: 'full',
      className: 'px-2',
    },
    {
      size: 'xsmall',
      rounded: 'base',
      className: 'px-1.5',
    },
    {
      size: 'small',
      rounded: 'full',
      className: 'px-2.5',
    },
    {
      size: 'small',
      rounded: 'base',
      className: 'px-2',
    },
    {
      size: 'base',
      rounded: 'full',
      className: 'px-3',
    },
    {
      size: 'base',
      rounded: 'base',
      className: 'px-2.5',
    },
    {
      size: 'large',
      rounded: 'full',
      className: 'px-3.5',
    },
    {
      size: 'large',
      rounded: 'base',
      className: 'px-3',
    },
  ],
  defaultVariants: {
    size: 'base',
    rounded: 'base',
  },
})
